import { render, staticRenderFns } from "./ReleaseSettings.vue?vue&type=template&id=10f7ec6a"
import script from "./ReleaseSettings.vue?vue&type=script&lang=js"
export * from "./ReleaseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports